import { render } from "./CatSearch.vue?vue&type=template&id=c545faee"
import script from "./CatSearch.vue?vue&type=script&lang=js"
export * from "./CatSearch.vue?vue&type=script&lang=js"

import "./CatSearch.vue?vue&type=style&index=0&id=c545faee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__